module.exports = global["$"] = require("-!E:\\project\\aiyukeFrontAll\\quanzi-pc\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");